import { FishingReport, Waterbody } from '@omniafishing/core';
import React from 'react';
import { useFishingReportListViewed } from '../../../../hooks/use_fishing_report_list_viewed';
import { useListAttributionUuid } from '../../../../hooks/use_list_attribution_uuid';
import { MapHotbaitCard } from '../lakes_modal/map_hotbait_card';

interface FeaturedMapHotbaitsProps {
  fishingReports: FishingReport[];
  loadMoreElementRef: (node: HTMLDivElement) => void;
  onReportHover?: (report: FishingReport | null) => void;
  onWaterbodyClick?: (waterbody: Waterbody) => void;
}
export const FeaturedMapHotbaits = React.memo((props: FeaturedMapHotbaitsProps) => {
  const { fishingReports, loadMoreElementRef, onReportHover, onWaterbodyClick } = props;

  useFishingReportListViewed(fishingReports, 'embedded', 0, fishingReports.length);
  const listUuid = useListAttributionUuid();

  return (
    <>
      {fishingReports.map((fr, i) => {
        return (
          <React.Fragment key={fr.id}>
            <li>
              {/* fetch more when reaching the 2nd to last item */}
              {fishingReports.indexOf(fr) === fishingReports.length - 2 && (
                <div ref={loadMoreElementRef} />
              )}
              <MapHotbaitCard
                fishingReport={fr}
                listUuid={listUuid}
                position={i}
                showLakeName
                onHover={onReportHover}
                onWaterbodyClick={onWaterbodyClick}
              />
            </li>
          </React.Fragment>
        );
      })}
    </>
  );
});
